import { FC, useCallback, useId, useRef, useState } from "react";
import { cn } from "../lib/utils";
import { BaseComponentProps } from "../types";
import { baseAttrs } from "../utils";
import { PortaledTooltip } from "./Tooltip";

export type TruncatedLabelProps = BaseComponentProps & {
	label: string;
	className?: string;
	onClick?: () => void;
	/** Hide the label from Amplitude and Sentry session replay and from Autocapture's element text. */
	mask?: boolean;
};

export const TruncatedLabel: FC<TruncatedLabelProps> = ({
	testId,
	label,
	className,
	onClick,
	mask,
}) => {
	const tooltipId = useId();
	const [showTooltip, setShowTooltip] = useState(false);
	const spanRef = useRef<HTMLSpanElement>(null);

	const handleMouseEnter = useCallback(() => {
		const el = spanRef.current;
		if (el && el.scrollWidth > el.clientWidth) {
			setShowTooltip(true);
		}
	}, []);

	const handleMouseLeave = useCallback(() => {
		setShowTooltip(false);
	}, []);

	return (
		<>
			<span
				{...baseAttrs({
					testId: testId ?? "truncated-label",
					className: cn("truncate", className),
				})}
				ref={spanRef}
				data-tooltip-id={tooltipId}
				data-amp-mask={mask ? "" : undefined}
				data-sentry-mask={mask ? "" : undefined}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onClick={onClick}
			>
				{label}
			</span>
			<PortaledTooltip
				id={tooltipId}
				content={label}
				isOpen={showTooltip}
				className={mask ? "sentry-mask" : undefined}
				style={{ zIndex: 200001 }}
			/>
		</>
	);
};
